"use client";

import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { format } from "date-fns";
import { ChevronDownIcon } from "lucide-react";
import { Matcher } from "react-day-picker";

interface DatePickerProps {
  id: string;
  value: Date | undefined;
  onChange: (value: Date | undefined) => void;
  min?: Date | undefined;
  max?: Date | undefined;
  disabled?: boolean;
}

export function DatePicker({
  id,
  value,
  onChange,
  min,
  max,
  disabled,
}: DatePickerProps) {
  const dateConstraints =
    min || max
      ? {
          ...(min ? { before: min } : {}),
          ...(max ? { after: max } : {}),
        }
      : undefined;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          id={id}
          variant="outline"
          data-empty={!value}
          className="data-[empty=true]:text-muted-foreground w-[212px] justify-between text-left font-normal"
          disabled={disabled}
        >
          <span className="truncate">
            {value ? format(value, "dd/MM/yyyy") : "Choisir une date..."}
          </span>
          <ChevronDownIcon />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={value}
          captionLayout="dropdown"
          defaultMonth={value}
          disabled={(dateConstraints as Matcher) || false}
          onSelect={(date) => {
            onChange(date);
          }}
        />
      </PopoverContent>
    </Popover>
  );
}
